export function isTouchDevice(): boolean {
  // Check for touch support
  if ('ontouchstart' in window) {
    return true
  }

  // Check for pointer support (modern approach)
  if (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
    return true
  }

  // Check for Microsoft pointer support
  if ((navigator as any).msMaxTouchPoints && (navigator as any).msMaxTouchPoints > 0) {
    return true
  }

  // Check media query for coarse pointer (typical for touch devices)
  if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
    return true
  }

  return false
}

export function isMobileDevice(): boolean {
  // Check user agent for mobile devices
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera

  // Common mobile device patterns
  const mobilePattern = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i

  return mobilePattern.test(userAgent.toLowerCase())
}

export function isSmallScreen(): boolean {
  // Consider screens smaller than 768px as small (typical mobile breakpoint)
  return window.innerWidth < 768 || window.innerHeight < 600
}

export function shouldUseTouchControls(): boolean {
  // Use touch controls if device has touch capability OR is a small screen
  return isTouchDevice() || isMobileDevice() || isSmallScreen()
}
